<script setup lang="ts">
import type { IconKeys } from "@/components/ui/Icon/Icon.interface"
import { Icon } from "@/components/ui"

withDefaults(defineProps<{
  icon: IconKeys
  showIconBadge?: boolean
  includeActionsRow?: boolean
}>(), {
  showIconBadge: true,
  includeActionsRow: true,
})
</script>

<template>
  <div class="flex min-h-[40vh] flex-col items-center justify-center gap-6 px-6 py-12 text-center md:min-h-[50vh] md:py-16" data-test="guest-empty-state-panel">
    <div class="mx-auto flex w-full max-w-lg flex-col items-center gap-6 text-center">
      <div class="relative flex h-16 w-16 items-center justify-center rounded-2xl border border-primary/15 bg-white text-primary">
        <Icon :icon="icon" class="h-8 w-8" />
        <span
          v-if="showIconBadge"
          data-test="guest-empty-state-icon-badge"
          class="pointer-events-none absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary ring-2 ring-white"
        >
          +
        </span>
      </div>
      <div class="space-y-2">
        <h2 class="font-comfortaa text-xl font-semibold tracking-tight text-gray-900 md:text-2xl">
          <slot name="title" />
        </h2>
        <p class="mx-auto max-w-md font-montserrat text-sm leading-relaxed text-gray-600 md:text-base">
          <slot name="description" />
        </p>
      </div>
      <div v-if="includeActionsRow && $slots.actions" class="flex w-full max-w-sm flex-col gap-2 sm:flex-row sm:justify-center">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
